<template>
  <div class="flex h-screen dark:bg-surface-900">
    <div class="w-[80px] border-r dark:border-r-app-separator flex flex-col items-center pt-4 gap-4">
      <Skeleton v-for="n in 6" :key="n" shape="circle" size="40px" />
    </div>
    <div class="flex-1 flex flex-col items-center justify-center -mt-[400px] gap-4">
      <Skeleton shape="circle" size="64px" />
      <Skeleton width="280px" height="28px" borderRadius="8px" />
      <Skeleton width="768px" height="56px" borderRadius="12px" class="mt-4" />
    </div>
  </div>
</template>
